<template>
  <section class="relative">
    <div class="max-w-[1920px] p-4 md:px-[60px] lg:px-8 xl:px-[80px] 2xl:px-[120px] mx-auto space-y-[32px] md:space-y-[60px] my-[48px]">
      <div class="flex flex-col lg:flex-row justify-between space-y-4">
        <div class="flex justify-between w-full">
          <div class="flex flex-col">
            <RouterLink :to="{ name: 'home' }" class="text-black font-[400]" activeClass="!font-bold">Home</RouterLink>
            <RouterLink :to="{ name: 'products' }" class="text-black font-[400]" activeClass="font-bold">{{ t('footer.products') }}</RouterLink>
            <RouterLink :to="{ name: 'vision' }" class="text-black font-[400]" activeClass="font-bold">{{ t('footer.vision') }}</RouterLink>
            <RouterLink :to="{ name: 'team' }" class="text-black font-[400]" activeClass="font-bold">{{ t('footer.about') }}</RouterLink>
          </div>
          <div class="flex flex-col">
            <RouterLink :to="{ name: 'content', params: { key: 'imprint' } }" class="text-black">{{ t('footer.imprint') }}</RouterLink>
            <RouterLink :to="{ name: 'content', params: { key: 'terms' } }" class="text-black">{{ t('footer.terms') }}</RouterLink>
            <RouterLink :to="{ name: 'content', params: { key: 'privacy' } }" class="text-black">{{ t('footer.privacy') }}</RouterLink>
          </div>
          <div class="flex flex-col">
            <a href="https://linkedin.com/company/www-rosypet-com" class="text-black">LinkedIn</a>
            <a href="https://www.youtube.com/channel/UCLF1V5b_KHSS5IxsT7dORkQ" class="text-black">Youtube</a>
          </div>
        </div>
      </div>
      <div class="block lg:flex items-end justify-between space-y-[24px]  md:space-y-0 md:pr-10">
        <div class="w-full lg:w-[450px]  pb-4">
          <VaButton
            color="pink-500"
            round
            :to="{ name: 'contact' }"
          >
            <span class="py-2 px-[34px] text-[16px] lg:text[18px] xl:text-[22px]">{{ t('footer.contactButton') }}</span>
          </VaButton>
        </div>
      </div>
      <div class="block md:flex justify-between border-t border-gray-100 space-y-[12px] md:space-y-0 py-[20px] md:py-[50px]">
        <p class="text-[18px] lg:text-[20px] xl:text-[22px] text-gray-100 font-[400] leading-none pb-3">Copyright Trex AG</p>
        <p class="text-[18px] lg:text-[20px] xl:text-[22px] text-gray-100 font-[400] leading-none pb-3">&nbsp;</p>
        <p @click="scrollToTop" class="text-[18px] lg:text-[20px] xl:text-[22px] text-gray-100 font-[400] leading-none pb-0">{{ t('footer.top') }}</p>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { VaButton } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const scrollToTop = () => {
  // get the scroll container #scroll
  const el = document.getElementById('scroll')
  if (!el) return
  el.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
</script>
